import { render, staticRenderFns } from "./Apolices.vue?vue&type=template&id=a54920ae"
import script from "./Apolices.vue?vue&type=script&lang=js"
export * from "./Apolices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports